module.exports = __webpack_public_path__ + "img/ywbk18_en.a3eaf679.jpg";